import { redirect } from 'next/navigation'
import { eq } from 'drizzle-orm'
import { auth } from '@/auth'
import { db } from '@/db'
import { users } from '@/db/schema'
import SettingsClient from './SettingsClient'

export default async function SettingsPage() {
  const session = await auth()
  if (!session?.user?.id) redirect('/login')

  const [user] = await db
    .select({ displayName: users.displayName, email: users.email, timeZone: users.timeZone })
    .from(users)
    .where(eq(users.id, session.user.id))
    .limit(1)

  const parts = user?.displayName?.split(' ') ?? []
  const firstName = parts[0] ?? ''
  const lastName = parts.slice(1).join(' ')

  return (
    <main className="min-h-screen bg-zinc-50 px-4 py-10 text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100">
      <div className="mx-auto max-w-lg space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-zinc-950 dark:text-white">Settings</h1>
          <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">{user?.email}</p>
        </div>
        <SettingsClient
          initialFirstName={firstName}
          initialLastName={lastName}
          initialTimeZone={user?.timeZone ?? null}
        />
      </div>
    </main>
  )
}
